import { createContext } from 'react';
import { AnalyticsBlockType } from './models';
import { combineBlocks } from './utils';

const defaultGenerator: any = (blocks?: AnalyticsBlockType) =>
  blocks ? combineBlocks(blocks, {}) : {};

export const DataLayerContext = createContext(defaultGenerator);
